export default {
    namespaced: true,
    state() {
        return {
            first_name: null,
            last_name: null,
            session_id: null,
            user_id: null
        }
    },
    getters: {
        first_name(state) {
            if (state.first_name === null) {
                state.first_name = localStorage.getItem("first_name");
            }
            return state.first_name;
        },
        last_name(state) {
            if (state.last_name === null) {
                state.last_name = localStorage.getItem("last_name")
            }
            return state.last_name;
        },
        full_name(state, getters) {
            let first = getters.first_name;
            let last = getters.last_name;
            if (typeof first === "string" && typeof last === "string") return first + " " + last;
            else if (typeof first === "string") return first;
            else if (typeof last === "string") return last;
            else return "Guest";
        },
        session_id(state) {
            console.log(state, typeof state.session_id);
            if (state.session_id === null) {
                state.session_id = localStorage.getItem("session_id");
            }
            return state.session_id;
        },
        user_id(state) {
            if (state.user_id === null) {
                let temp = parseInt(localStorage.getItem("user_id"));
                state.user_id = isNaN(temp) ? null : temp;
            }
            return state.user_id || -1;
        }
    },
    mutations: {
        setName(state, {firstName, lastName}) {
            state.first_name = firstName;
            if(firstName){
                localStorage.setItem("first_name", firstName);
            } else {
                localStorage.removeItem("first_name");
            }
            state.last_name = lastName;
            if(lastName){
                localStorage.setItem("last_name", lastName);
            } else {
                localStorage.removeItem("last_name");
            }
        },
        setSessionId(state, id) {
            console.log(id);
            state.session_id = id;
            if (id) {
                localStorage.setItem("session_id", id);
            } else {
                localStorage.removeItem("session_id");
            }
        },
        setUserId(state, user) {
            // 'user' is an email, so let's not store that
            if (user) {
                let hash = 0, i, chr;
                if (user.length === 0) return hash;
                for (i = 0; i < user.length; i++) {
                    chr = user.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0; // Convert to 32bit integer
                }
                state.user_id = hash;
                localStorage.setItem("user_id", hash.toString());
            } else {
                state.user_id = undefined;
                localStorage.removeItem("user_id");
            }
        },
        setUserIdDirect(state, user) {
            state.user_id = user;
            localStorage.setItem("user_id", user.toString());
        }
    },
    actions: {
        deleteUser(context) {
            context.commit("setName", {firstName: undefined, lastName: undefined});
            context.commit("setSessionId", undefined);
            context.commit("setUserId", undefined);
        }
        // loadUser(context){
        //
        // }
    }
}
